<template>
  <v-switch
    v-if="definition.type == 'boolean'"
    :input-value="switchValue"
    @change="$emit('input', $event ? 'true' : 'false')"
    :label="label"
    :hint="definition.hint"
    :persistent-hint="!!definition.hint"
    :hide-details="!definition.hint"
    class="mt-0"
    dense
  ></v-switch>
  <v-text-field
    v-else
    :value="value"
    @input="$emit('input', $event)"
    :label="label"
    :type="inputType"
    :hint="definition.hint"
    :persistent-hint="!!definition.hint"
    :hide-details="!definition.hint"
    :append-icon="definition.type == 'password' ? (reveal ? 'mdi-eye-off' : 'mdi-eye') : undefined"
    @click:append="reveal = !reveal"
    :outlined="outlined"
    :dense="dense"
    autocomplete="off"
  ></v-text-field>
</template>

<script>
import {
  thirdPartySettingDefinition,
  isTrueSetting,
} from "../../../../constants/thirdPartySetups";

// One Third Party Setting value, typed by the known setup templates (#11460):
// switch for booleans ("true"/"false"), masked input for secrets, number for counts.
export default {
  name: "third-party-setting-input",

  props: {
    value: {
      type: String,
      default: "",
    },
    setupName: {
      type: String,
      default: "",
    },
    settingName: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Value",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      reveal: false,
    };
  },

  computed: {
    definition() {
      return thirdPartySettingDefinition(this.setupName, this.settingName);
    },
    // a blank setting means the server-side default
    switchValue() {
      const content = (this.value || "").toString().trim();
      return isTrueSetting(content || this.definition.default);
    },
    inputType() {
      if (this.definition.type == "password") return this.reveal ? "text" : "password";
      if (this.definition.type == "number") return "number";
      return "text";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/shared/third-party-setups/ThirdPartySettingInput.vue